export const PASSWORD_MIN_LENGTH = 8

export type PasswordBasicError = "minLength" | "notNumeric"

export const getPasswordBasicErrors = (
  password: string
): PasswordBasicError[] => {
  const errors: PasswordBasicError[] = []

  if (password.length < PASSWORD_MIN_LENGTH) {
    errors.push("minLength")
  }

  if (/^\d+$/.test(password)) {
    errors.push("notNumeric")
  }

  return errors
}

export const isPasswordBasicValid = (password: string): boolean =>
  getPasswordBasicErrors(password).length === 0

export const getFirstPasswordBasicError = (
  password: string
): PasswordBasicError | null => getPasswordBasicErrors(password)[0] ?? null

export type NewPasswordFormError =
  | "passwordRequired"
  | "confirmPasswordRequired"
  | "passwordsDoNotMatch"
  | "passwordPolicy"

export interface NewPasswordFormValidationInput {
  password: string
  confirmPassword?: string
  requireConfirmation?: boolean
}

export const getNewPasswordFormError = ({
  password,
  confirmPassword = "",
  requireConfirmation = true,
}: NewPasswordFormValidationInput): NewPasswordFormError | null => {
  if (!password) return "passwordRequired"
  if (requireConfirmation && !confirmPassword) return "confirmPasswordRequired"
  if (requireConfirmation && password !== confirmPassword) {
    return "passwordsDoNotMatch"
  }
  if (!isPasswordBasicValid(password)) return "passwordPolicy"
  return null
}
